<template>
  <div>
    <b-modal
      size="xl"
      header="Catalog tree"
      border-variant="info"
      header-bg-variant="primary"
      header-text-variant="white"
      v-model="isshow"
      no-close-on-backdrop
      id="ordermodal"
      v-if="isshow && currentOrderData"
    >
      <div slot="modal-header">
        New Order #
        <b>{{ currentOrderData.fullfillmentId }}</b>
      </div>
      <div>
        <div class="row">
          <div class="col-lg-5">
            <div class="card">
              <div class="card-body">
                <h5 class="header-title">Order Details</h5>
                <ul class="list-unstyled">
                  <li>
                    <span class="font-weight-bold mb-3">Amount :</span>
                    {{ currentOrderData.orderAmount }}
                  </li>
                  <li class="order-modal-list-item">
                    <span class="font-weight-bold mb-3">Payment Type :</span>
                    {{ currentOrderData.paymentType }}
                  </li>
                  <li class="order-modal-list-item">
                    <span class="font-weight-bold mb-3">Delivery Charge :</span>
                    {{ currentOrderData.deliveryCharges }}
                    {{ currentOrderData.orderCurrency }}
                  </li>
                </ul>
                <div
                  v-if="
                    currentOrderData.deliveryAddress &&
                    currentOrderData.deliveryAddress.address
                  "
                >
                  <h5 class="header-title mt-3">Delivery Address</h5>
                  <address
                    class="mb-0 font-15 address-lg"
                    v-if="currentOrderData.deliveryAddress.address"
                  >
                    {{ currentOrderData.deliveryAddress.address.houseNumber }} ,
                    {{ currentOrderData.deliveryAddress.address.street1 }},
                    {{ currentOrderData.deliveryAddress.address.street2 }}
                    <br />
                    <span class="mb-2">City :</span>
                    {{ currentOrderData.deliveryAddress.address.city }} -
                    {{ currentOrderData.deliveryAddress.address.state }} ({{
                      currentOrderData.deliveryAddress.address.country
                    }})
                    <br />
                    <span class="mb-2">Pincode :</span>
                    {{ currentOrderData.deliveryAddress.address.zip }}
                    <br />
                  </address>
                </div>
                <b-row class="mt-3">
                  <b-col>
                    <div>
                      <h5>
                        ETA <i class="ti-calendar icon-black"></i> :
                      </h5>
                      <div>
                        <input
                          class="form-control eta-input-yellow"
                          type="datetime-local"
                          id="example-datetime-local-input"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col>
                    <div>
                      <h5>Pick up time :</h5>
                      <div>
                        <input
                          class="form-control eta-input-yellow"
                          type="datetime-local"
                          id="example-datetime-local-input"
                        />
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
          <div class="col-lg-7">
            <div class="card">
              <div>
                  <div class="wrap">
                    <table class="table table-centered mb-0 order-items-table">
                    <thead class="thead-dark">
                      <tr>
                        <th>No</th>
                        <th>Item Image</th>
                        <th>Name</th>
                        <th>Price</th>
                        <th>Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, idx) in currentOrderData.items"
                        :key="'arr' + idx"
                      >
                        <td>{{ idx + 1 }}</td>
                        <td>
                          <img
                            class="mr-2 rounded"
                            :src="item.imageLink"
                            alt="Generic placeholder image"
                            height="42"
                          />
                        </td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.price }}</td>
                        <td>
                          <i class="mdi mdi-circle text-success"></i>
                          {{ item.qty }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div
        slot="modal-footer"
        v-if="newOrderNotification.message.type === 'order-request'"
      >
        <b-button variant="primary" @click="acceptOrder">Accept</b-button>
        <b-button class="ml-2" variant="danger" @click="rejectOrder"
          >Reject</b-button
        >
        <b-button class="ml-2" variant="warning" @click="isshow = false"
          >Ignore</b-button
        >
      </div>
      <div
        slot="modal-footer"
        v-if="
          newOrderNotification.message.type === 'manufacturer-order-request'
        "
      >
        <b-button class="ml-2" variant="warning" @click="isshow = false"
          >Close</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  name: "OrderModal",
  data() {
    return {
      ETATime: "",
      pickUpTime: "",
      isshow: true,
    };
  },
  computed: {
    currentOrderData() {
      return this.$store.getters["notification/GetCurrentOrderDetails"];
    },
    newOrderNotification() {
      return this.$store.getters["notification/GetNewOrderNotification"];
    },
  },
  methods: {
    async acceptOrder() {
      let taskdata = await Axios.get(
        this.newOrderNotification.message.taskDataLink
      );

      let payload = {
        url: this.newOrderNotification.message.taskUpdateLink,
        data: {
          workflowInstanceId: taskdata.data.taskStatus.workflowInstanceId,
          taskId: taskdata.data.taskStatus.taskId,
          status: "COMPLETED",
          outputData: {
            approval: true,
            eta: this.ETATime,
            pickUpTime: this.pickUpTime,
          },
        },
      };
      this.$store.dispatch("order/acceptCurrentOrder", payload).then((res) => {
        this.isshow = false;
        let messageObj = {
          id: this.newOrderNotification._id,
        };
        let userdata = JSON.parse(sessionStorage.getItem("userLogin"));
        let object = {
          uid: userdata._id,
        };

        this.$socket.emit("read", messageObj);
        this.$socket.emit("getunread", object);
        this.ETATime = "";
        this.pickUpTime = "";
        this.$swal({
          title: "Accepted!",
          text: "New Order Accepted Successfully!",
          type: "success",
        });
      });
    },
    async rejectOrder() {
      let taskdata = await Axios.get(
        this.newOrderNotification.message.taskDataLink
      );

      let payload = {
        url: this.newOrderNotification.message.taskUpdateLink,
        data: {
          workflowInstanceId: taskdata.data.taskStatus.workflowInstanceId,
          taskId: taskdata.data.taskStatus.taskId,
          status: "COMPLETED",
          outputData: {
            approval: false,
            eta: this.ETATime,
            pickUpTime: this.pickUpTime,
          },
        },
      };
      this.$store.dispatch("order/acceptCurrentOrder", payload).then((res) => {
        this.isshow = false;
        let messageObj = {
          id: this.newOrderNotification._id,
        };
        let userdata = JSON.parse(sessionStorage.getItem("userLogin"));
        let object = {
          uid: userdata._id,
        };

        this.$socket.emit("read", messageObj);
        this.$socket.emit("getunread", object);
        this.$swal({
          title: "Rejected!",
          text: "Order is Rejected!",
          type: "success",
        });
      });
    },
  },
};
</script>
<style scoped>
.order-modal-list-item {
  margin-top: 5px;
}

.icon-black {
  color: black;
}

.eta-input-yellow {
  width: 46%;
  background-color: #ffeea9;
}

.wrap {
  overflow-x: auto;
}

.order-items-table {
  border-collapse: collapse;
  display: inline-block;
  max-height: 450px;
  overflow: auto;
  width: 100%;
}

.order-items-table th {
  position: sticky;
  top: 0;
  background-color: #343a40;
  z-index: 10;
}

.order-items-table th,
.order-items-table td {
  padding: 1em 0.5em;
}

.order-items-table tr {
  color: #212121;
}

@media (max-width: 767.98px) {
  .order-items-table {
    max-height: 300px;
  }
}

.order-modal-list-item {
  margin-top: 5px;
}

.icon-black {
  color: black;
}

.eta-input-yellow {
  width: 46%;
  background-color: #ffeea9;
}

@media (max-width: 767.98px) {
  .eta-input-yellow {
    width: 100%;
  }
}
</style>
